// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// COMPONENTS
import Title from 'components/text/Title';
import Icon from 'components/common/Icon';
import Subtitle from 'components/text/Subtitle';

// STYLED-COMPONENTS
// =========================
const ErrorStateContainer = styled.div`
  height: 175px;
  width: 320px;
  max-width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  margin: auto;
  text-align: center;
`;

const StyledSubtitle = styled(Subtitle)`
  display: block;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 7px;
  font-size: 12px;
`;

const ErrorIcon = styled(Icon)`
  color: ${p => p.theme.colorError};
  font-size: 40px;
  margin-bottom: 5px;
`;

// EXPORTED COMPONENT
// =========================
const ErrorState = ({ message, title }) => (
  <ErrorStateContainer>
    <div>
      <div>
        <ErrorIcon type="close-circle-o" />
      </div>
      {title && <Title style={{ display: 'block' }}>{title}</Title>}
      <StyledSubtitle>{message}</StyledSubtitle>
    </div>
  </ErrorStateContainer>
);

// PROPS
// =========================
ErrorState.defaultProps = {
  message: 'Something went wrong...',
};

// EXPORT
// =========================
export default ErrorState;



// WEBPACK FOOTER //
// ./src/components/common/ErrorState/index.js